'use client'

import * as React from 'react'
import {
  ShowcaseStrip,
  buildShowcaseVideos,
} from '@repo/studio-components-showcase-strip/showcase-strip'
import { InfiniteCarousel } from '../infinite-carousel'
import { SeedanceVideoItem } from './seedance-video-item'

const LFS_URL = process.env.NEXT_PUBLIC_LFS_URL ?? ''

const SHOWCASE_VIDEOS = buildShowcaseVideos(`${LFS_URL}/studio/video/seedance-2-0`, 'seedance')

interface SeedanceStripProps {
  title: string
  tryItLabel: string
  viewLabel: string
  scrollLeftLabel: string
  scrollRightLabel: string
  showHoverOverlay?: boolean
  className?: string
}

export function SeedanceStrip({
  title,
  tryItLabel,
  viewLabel,
  scrollLeftLabel,
  scrollRightLabel,
  showHoverOverlay = false,
  className = '',
}: SeedanceStripProps) {
  const loopedVideos = React.useMemo(
    () => [...SHOWCASE_VIDEOS, ...SHOWCASE_VIDEOS, ...SHOWCASE_VIDEOS],
    [],
  )

  return (
    <ShowcaseStrip.Root className={`gap-2 ${className}`}>
      <ShowcaseStrip.Title className="text-base font-semibold font-poppins text-cf-black">
        {title}
      </ShowcaseStrip.Title>
      <InfiniteCarousel
        itemCount={SHOWCASE_VIDEOS.length}
        scrollLeftLabel={scrollLeftLabel}
        scrollRightLabel={scrollRightLabel}
      >
        {loopedVideos.map((video, index) => {
          const setIndex = Math.floor(index / SHOWCASE_VIDEOS.length)
          return (
            <SeedanceVideoItem
              key={`${video.id}-${setIndex}`}
              data-card
              src={video.previewUrl}
              tryItLabel={tryItLabel}
              viewLabel={viewLabel}
              showHoverOverlay={showHoverOverlay}
              aspectClassName="aspect-[9/16]"
            />
          )
        })}
      </InfiniteCarousel>
    </ShowcaseStrip.Root>
  )
}
